<div class="container">
  @if (blockedUi) {
  <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
    <i class="pi pi-spin pi-spinner loading" [style.display]="blockedUi ? 'block' : 'none'"></i>
  </div>
  }
  <div class="grid container-header">
    <div class="col-12 md:col-12 lg:col-12 title-position">
      <span class="title" id="titleDetails">{{ 'TRANSLATE.PRICE.DETAILS' | translate }}</span>
      <span class="title" id="titleEdit">{{ 'TRANSLATE.EDIT.PRICE' | translate }}</span>
      <span class="sub-title" id="subTitle">{{ 'TRANSLATE.REVIEW.UPDATE.PRICE.INFORMATION' | translate }}</span>
    </div>
  </div>

  <div class="container-body">
    <div class="col-12 md:col-12 lg:col-12 product-itens">

      <div class="col-12 md:col-12 lg:col-12 message-edit">

        <div class="col-12 md:col-6 lg:col-4 element-edit space-first">
          <label class="element-edit-label" for="priceId">{{ 'TRANSLATE.PRICE.ID' | translate }} </label>
          <input class="element-edit-input disabled-input" id="priceId" type="text" [(ngModel)]="price.priceId" disabled
            pInputText>
        </div>

        <div class="col-12 md:col-6 lg:col-4 element-edit space-second">
          <label class="element-edit-label" for="namePrice">{{ 'TRANSLATE.PRICE.NAME' | translate }}</label>
          <p-dropdown [options]="listNamePrice" id="namePrice" [(ngModel)]="price.itemName"
            placeholder="{{ 'TRANSLATE.SELECT' | translate }}" (onChange)="namePriceChange($event)"
            [disabled]="selectDisabled" [style]="{'minWidth': '100%'}">
            <ng-template pTemplate="item" let-item>
              {{item?.label | translate}}
            </ng-template>
            <ng-template pTemplate="selectedItem" let-item>
              {{item?.label | translate}}
            </ng-template>
          </p-dropdown>

          <div class="message-edit">

            @if (isEditingMode && hasAttemptedSave && (selectedNamePrice === undefined || selectedNamePrice === null ||
            selectedNamePrice === '' || selectedNamePrice === 'TRANSLATE.SELECT')) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.SELECT.NAME.PRICE' | translate }}">
            </p-message>
            }
          </div>
        </div>

        <div class="col-12 md:col-6 lg:col-4 element-edit space-second">
          <label class="element-edit-label" for="currency">{{ 'TRANSLATE.CURRENCY' | translate }}</label>
          <p-dropdown [options]="listCurrency" id="currency" [(ngModel)]="price.itemPriceUnit"
            placeholder="{{ 'TRANSLATE.SELECT' | translate }}" (onChange)="currencyChange($event)"
            [disabled]="selectDisabled" [style]="{'minWidth': '100%'}">
            <ng-template pTemplate="item" let-item>
              {{item?.label | translate}}
            </ng-template>
            <ng-template pTemplate="selectedItem" let-item>
              {{item?.label | translate}}
            </ng-template>
          </p-dropdown>

          <div class="message-edit">
            @if (isEditingMode && hasAttemptedSave && (selectedCurrency === undefined || selectedCurrency === null ||
            selectedCurrency === '')) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.SELECT.CURRENCY' | translate }}">
            </p-message>
            }
          </div>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-12 message-edit">

        <div class="col-12 md:col-6 lg:col-4 element-edit space-first">
          <label class="element-edit-label" for="valuePrice">{{ 'TRANSLATE.VALUE' | translate }}</label>
          <input class="element-edit-input large-text disabled-input" id="valuePrice" [(ngModel)]="frontPrice"
            type="text" minlength="1" maxlength="13" (input)="priceFormatting($event)" pInputText>

          <div class="message-edit">
            @if (isPriceValueEmpty()) {
            <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.INFORM.VALUE' | translate }}">
            </p-message>
            } @else if (isPriceValueZeroOrLess()) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORM.VALUE.CANNOT.BE.ZERO.OR.LESS' | translate }}">
            </p-message>
            }
          </div>
        </div>

      </div>

      <div class="col-12 md:col-12 lg:col-12 message-edit">

        <div class="col-12 md:col-12 lg:col-12 element-edit space-first">
          <label class="element-edit-label" for="priceDescription">{{ 'TRANSLATE.DESCRIPTION.PRICE' | translate
            }}</label>
          <textarea class="element-edit-input disabled-input" id="priceDescription" [(ngModel)]="price.itemDescription"
            type="text" minlength="4" maxlength="100" disabled pInputTextarea></textarea>

          <div class="char-counter">
            {{ price.itemDescription?.length || 0 }} {{ 'TRANSLATE.MAX.CHARACTERS.100' | translate }}
          </div>

          <div class="message-edit">
            @if (isPriceDescriptionEmpty()) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORM.DESCRIPTION.PRICE' | translate }}">
            </p-message>
            } @else if (isPriceDescriptionTooShort()) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.MIN.LENGTH.PRICE.DESCRIPTION' | translate }}">
            </p-message>
            }
          </div>
        </div>
      </div>

    </div>

    <div class="col-12 md:col-12 lg:col-12 button-position">

      @if (!isEditingMode) {
      <button id="btnReturn" class="undo-action-button app-clean-button" type="button" (click)="buttonReturn()">
        <i class="pi pi-arrow-left" aria-hidden="true"></i>
        <span class="undo-action-button-label">{{ 'TRANSLATE.RETURN' | translate }}</span>
      </button>
      }

      @if (!isEditingMode) {
      <button id="btnEdit" class="action-button app-filter-button" type="button" (click)="buttonEdit()">
        <i class="pi pi-pencil" aria-hidden="true"></i>
        <span class="action-button-label">{{ 'TRANSLATE.EDIT' | translate }}</span>
      </button>
      }

      @if (isEditingMode) {
      <button id="btnCancel" class="undo-action-button app-clean-button" type="button" (click)="buttonCancel()"
        [disabled]="blockedUi">
        <i class="pi pi-times" aria-hidden="true"></i>
        <span class="undo-action-button-label">{{ 'TRANSLATE.CANCEL' | translate }}</span>
      </button>
      }

      @if (isEditingMode) {
      <button id="btnSave" class="action-button app-filter-button" type="submit" (click)="buttonSave()"
        [disabled]="blockedUi">
        @if (!blockedUi) {
        <i class="pi pi-check" aria-hidden="true"></i>
        }
        @if (blockedUi) {
        <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
        }
        <span class="action-button-label">{{ (blockedUi ? 'TRANSLATE.SAVING' : 'TRANSLATE.SAVE') | translate }}</span>
      </button>
      }

    </div>

  </div>

</div>